<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="hugo-flies">
<h1>Hugo Flies</h1>
<p>7 PM on Saturday. ‘The Place’ is packed. Inside and out. Beth and the staff are struggling to keep up. Abe had even been allowed to help with the coffee and tea making process. Something Beth had essentially banned him from a couple years back.</p>
<p>As the band, this time a threesome of 50-somethings known as the Wannasea Boys, sets up. Abe keeps his ear toward the dining floor. Seems <em>Hugo</em> is this night’s favorite.</p>
<p>As Beth delivers a handful of receipts to Abe, Abe says, “You need to get more help, Kitten. At least from Thursday through Saturday.”</p>
<p>“I’m working on it, Abe.”</p>
<p>“Can you afford to pay them? If you can’t, I’ll help out.”</p>
<p>Beth narrows her eyes and scowls at her grandfather.</p>
<p>“Believe me, I can afford it.”</p>
<p>Beth scoots off to the small stage and turns on the microphone.</p>
<p>“Great to see everyone tonight. Welcome to ‘The Place.’ If you haven’t been here before, we’ll start out the night with a little poetry reading from Abe. That is if Abe has enough time to spare from the time and efficiency study that he’s been working on tonight.”</p>
<p>Beth stares out at her grandfather, who puts up his hands in an I-give-up gesture.</p>
<p>“Seems most of you would like to hear <em>Hugo Flies</em>. Have I gotten that right?”</p>
<p>The crowd responds affirmatively.</p>
<p>“Then with no further ado, my grandfather will read the words of the poem leading to the lyrics of the song which became Reggie Reginald’s first hit.”</p>
<p>Abe strolls to the stage. Careful not to cross Beth’s path.</p>
<p>“My most wonderful, beautiful granddaughter, folks,” Abe said gesturing toward Beth.</p>
<p>The crowd responded with a round of polite applause.</p>
<p>Abe nods to the band, adjusts the microphone and begins reading the poem which had not only become the genesis of Reggie Reginald, but also of Abe’s and his wife’s songwriting careers.</p>
<p><strong><em>Hugo Flies</em></strong> (Reggie style at a tempo of 116 in the key of C Major in 4/4 time)</p><br/>
<div class="align">
<p>what came after Nine were Hugo and Alice</p>
<p>a tall thin cool drink of water, a lady quite capable of malice</p>
<p>Hugo, head in the clouds and sights on the stars</p>
<p>Alice, more interested in making history than reading memoirs</p><br/>
<p>mind in the clouds</p>
<p>flying straight toward the sun</p>
<p>Hugo had only just begun</p><br/>
<p>making the most of his aerial desires</p>
<p>Hugo went from trainee to the highest of fliers</p>
<p>Alice focused on studies and raising a daughter</p>
<p>As the planet’s first great war grew ever hotter</p><br/>
<p>mind in the clouds</p>
<p>flying straight toward the sun</p>
<p>Hugo had only just begun</p><br/>
<p>what came after Nine were Hugo and Alice</p>
<p>tall thin cool drink of water, elegant lady quite capable of malice</p>
<p>war moved Hugo across the continent</p>
<p>where the Allies worked to establish air dominance</p>
<p>in six short months, Hugo became an ace</p>
<p>the best fighter pilot in hostile airspace</p><br/>
<p>Hugo wrote to Alice every chance that he had</p>
<p>expressing his longings in words loving and sad</p>
<p>Each mission becoming ever more gory</p>
<p>As Hugo covered himself in honors and glory</p><br/>
<p>mind in the clouds</p>
<p>flying straight toward the sun</p>
<p>Hugo had only just begun</p><br/>
<p>With the Allies planning a last major push</p>
<p>Hugo and squadron plotted an aerial ambush</p>
<p>In hope of reducing the number of corpses</p>
<p>a plan was made to distract the Kaiser’s forces</p><br/>
<p>what came after Nine were Hugo and Alice</p>
<p>tall thin cool drink of water, elegant lady quite capable of malice</p><br/>
<p>Hugo led the assault on the Kaiser’s back lines</p>
<p>hand releasing two bombs per their plan’s designs</p>
<p>dropping low to explode an ammunition shack</p>
<p>thus aiding the Allies rapidly advancing attack</p><br/>
<p>the Kaiser’s air fighters came at ten o’clock</p>
<p>non-stop anti-aircraft fire, a much greater shock</p>
<p>Hugo pointed his Vickers DH2 toward the sky</p>
<p>avoiding a Fokker’s fire by the blink of an eye</p><br/>
<p>Hugo watched an artillery shell whiz by his propeller</p>
<p>thinking perhaps once again he was one very lucky fella</p>
<p>but the secondary explosion meant he was done</p>
<p>Hugo had flown himself straight into the sun</p><br/>
<p>what came after Hugo were Rebecca and peace</p>
<p>creating a pain in Alice’s heart which was never to cease</p>
<p>of Alice’s victory celebration, there was none</p>
<p>Alice began to do what had to be done</p>
<p>after Hugo had flown himself straight into the sun</p><br/>
<p>the Kaiser’s air fighters came at ten o’clock</p>
<p>non-stop anti-aircraft fire, a much greater shock</p>
<p>Hugo pointed his Vickers DH2 toward the sky</p>
<p>avoiding a Fokker’s fire by the blink of an eye</p><br/>
<p>Hugo watched an artillery shell whiz by his propeller</p>
<p>thinking perhaps once again he was one very lucky fella</p>
<p>but the secondary explosion meant he was done</p>
<p>Hugo had flown himself straight into the sun</p><br/>
<p>what came after Hugo were Rebecca and peace</p>
<p>creating a pain in Alice’s heart which was never to cease</p>
<p>mind in the clouds, flying straight toward the sun</p>
<p>ended what Hugo had only just begun</p>
<p>mind in the clouds, flying straight toward the sun</p>
<p>ended what Hugo had only just begun</p>
</div><br/>
<p>Abe did the reading once more before heading back to the stool behind the cash register.</p>
<p><strong><span style="text-decoration: underline;"><br/>
</span></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?62e2fc10